import React from "react";
import OwnerAssignment from "../../StateMachine/OwnerAssignment";
import { useAppUserContext } from "../../../context/AppUserContext";

const AppUserSettings = () => {
  const { appUserData, setAppUserData } = useAppUserContext();
  const settingOwnerAssignment = (newOwner) => {
    setAppUserData({
      ...appUserData,
      appuser_owner_assignment: newOwner
    });
  };

  return (
    <div className="d_flex justify_center mt_5">
      <div className="border_full">
        <OwnerAssignment
          ownerAssignment={appUserData.appuser_owner_assignment || {}}
          setOwnerAssignment={settingOwnerAssignment}
        />
      </div>
    </div>
  );
};

export default AppUserSettings;
